
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _genqIpHwTH65ZL9OQf5fOEAjnC4FJIEeBUUB3ZT9yduylwMeta } from "/codebuild/output/src4045856627/src/codestar-connections.eu-central-1.amazonaws.com/git-http/590183747426/eu-central-1/94facd3c-401c-440c-99a1-7824e47bf76e/studyportals/OmniSearch/src/app/pages/_gen.vue?macro=true";
import { default as _91_46_46_46catchall_93z3BMagBC3OlwuiXFfxFFsEuAUrRNg42QrSp1pK9PTQYMeta } from "/codebuild/output/src4045856627/src/codestar-connections.eu-central-1.amazonaws.com/git-http/590183747426/eu-central-1/94facd3c-401c-440c-99a1-7824e47bf76e/studyportals/OmniSearch/src/app/pages/[...catchall].vue?macro=true";
export default [
  {
    name: "_gen",
    path: "/_gen",
    component: () => import("/codebuild/output/src4045856627/src/codestar-connections.eu-central-1.amazonaws.com/git-http/590183747426/eu-central-1/94facd3c-401c-440c-99a1-7824e47bf76e/studyportals/OmniSearch/src/app/pages/_gen.vue")
  },
  {
    name: "catchall",
    path: "/:catchall(.*)*",
    component: () => import("/codebuild/output/src4045856627/src/codestar-connections.eu-central-1.amazonaws.com/git-http/590183747426/eu-central-1/94facd3c-401c-440c-99a1-7824e47bf76e/studyportals/OmniSearch/src/app/pages/[...catchall].vue")
  }
]